import { ALGOS_E } from "@constants/Algos";

export enum HASH_DECIMALS_E {
  // H = 1,
  N = 1,
  K = 1000,
  M = 1000000,
  G = 1000000000,
  T = 1000000000000,
  P = 1000000000000000,
  E = 1000000000000000000,
}

export const HASH_DECIMALS = {
  // H = 1,
  N: 1,
  K: 1000,
  M: 1000000,
  G: 1000000000,
  T: 1000000000000,
  P: 1000000000000000,
  E: 1000000000000000000,
}


export enum HashFactorName {
  // H = "H",
  N = "",
  K = "K",
  M = "M",
  G = "G",
  T = "T",
  P = "P",
  E = "E",
}

export enum UNIT_NAME {
  all = "H/s",
  scrypt = "H/s",
  sha256 = "H/s",
  equihash = "Sol/s",
}

export const HashArr = Object.keys(HASH_DECIMALS_E).filter((opt) =>
  isNaN(+opt)
);

export const calculateHash = (
  hash: number | string,
  factorName: HashFactorName
) => {
  return Number(hash) * getFactor(factorName);
};

export const getDevivedHash = (
  hash: number | string | undefined,
  options: {
    unit?: ALGOS_E;
    hashFactor?: HashFactorName
  } = {
      unit: ALGOS_E.SHA256,
    }
): string => {

  const unitKey = options.unit
    ? options.unit
    : (ALGOS_E.SHA256 as keyof typeof UNIT_NAME);

  const unitStr = UNIT_NAME[unitKey];

  if (!hash || hash === "0" || isNaN(hash as number)) return `0 ${unitStr}`;
  const h =
    typeof hash === "string"
      ? Number(hash.replace(/\s+/g, "").split(",")[0])
      : hash;

  let res = "";
  // если есть самое низкое значение хеша - считаем все по этому значению
  if (options.hashFactor) {
    return (res = `${(
      h / HASH_DECIMALS_E[options.hashFactor as keyof typeof HASH_DECIMALS_E]
    ).toFixed(2)} ${options.hashFactor}${unitStr}`);
  }

  for (let k in HASH_DECIMALS_E) {
    const key = k as keyof typeof HASH_DECIMALS_E;
    const decimal = HASH_DECIMALS_E[key];
    if (h / decimal >= 1)
      res = `${(h / decimal).toFixed(2)} ${HashFactorName[key]}${unitStr}`;
  }

  return res;
};

export const lowerHashDecimal = (arr: number[]): string => {
  if (!arr) return "";
  //const ar = arr.map((num) => num);
  //const sorted = ar.sort((a, b) => a - b);
  const minHash = Math.min(...arr);
  const hash = getDevivedHash(minHash);
  return hash.split(" ")[1];
};

export const higherHashDecimal = (
  arr: number[],
  hashAlgo = ALGOS_E.SHA256
): string => {
  if (!arr) return "";
  const maxHash = Math.max(...arr); // quikSort(arr);
  const hash = getDevivedHash(maxHash, { unit: hashAlgo }); //sorted[sorted.length - 1], { unit: hashAlgo });
  return hash.split(" ")[1];
};

// function getOrderOfMagnitude(num) {
//   return Math.floor(Math.log10(num));
// }

export function getMaxSpeedTitle(
  values: number[],
  algo?: ALGOS_E,
): [number, string] {
  const algoUnit = algo ? UNIT_NAME[algo as keyof typeof UNIT_NAME] : UNIT_NAME.all;
  let shortSpeed = 0;
  let speedTitle = algoUnit.toString();
  if (values.length > 0) {
    const maxSpeed = Math.max(...values);
    for (let key in HASH_DECIMALS) {
      const decimal = HASH_DECIMALS[key as keyof typeof HASH_DECIMALS];
      shortSpeed = maxSpeed / decimal;
      speedTitle = `${HashFactorName[key as keyof typeof HASH_DECIMALS]}${algoUnit}`;
      if (shortSpeed < 1000) {
        return [shortSpeed, speedTitle];
      }
    }
  }
  return [shortSpeed, speedTitle];
}

export const getFactor = (name: HashFactorName): number => {
  for (let k in HASH_DECIMALS_E) {
    if (name.includes(k)) {
      return HASH_DECIMALS_E[k] as unknown as number;
    }
  }
  return HASH_DECIMALS_E.N;
};

export const getHashName = (
  hash?: number | string
): HashFactorName | undefined => {
  if (!hash) {
    // console.error("HASH is undefined (" + hash + ")");
    return;
  }
  const h = getDevivedHash(hash);
  return h.split(" ")[1] as HashFactorName;
};
